import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-statistique-volume-traiter',
  templateUrl: './statistique-volume-traiter.component.html',
  styleUrls: ['./statistique-volume-traiter.component.css']
})
export class StatistiqueVolumeTraiterComponent implements OnInit {
  donnee: any;
  constructor() { }

  ngOnInit(): void {
    this.donnee = [
      { date: '11/06/2020', moderation_nouveau: '20', moderation_retour: '5',
        description_nouveau: '2', description_retour: '5',
        site_web_nouveau: '7', site_web_retour: '6' ,
        lien_reseaux_nouveau: '7', lien_reseaux_retour: '6' ,
        photo_nouveau: '7', photo_retour: '6' ,
        logo_nouveau: '7', logo_retour: '6' ,
        offre_nouveau: '7', offre_retour: '6' },
      { date: '12/06/2020', moderation_nouveau: '30', moderation_retour: '12',
        description_nouveau: '2', description_retour: '5',
        site_web_nouveau: '7', site_web_retour: '6' ,
        lien_reseaux_nouveau: '7', lien_reseaux_retour: '6' ,
        photo_nouveau: '7', photo_retour: '6' ,
        logo_nouveau: '7', logo_retour: '6' ,
        offre_nouveau: '7', offre_retour: '6' },
      { date: '12/06/2020', moderation_nouveau: '50', moderation_retour: '17',
        description_nouveau: '2', description_retour: '5',
        site_web_nouveau: '7', site_web_retour: '6' ,
        lien_reseaux_nouveau: '7', lien_reseaux_retour: '6' ,
        photo_nouveau: '7', photo_retour: '6' ,
        logo_nouveau: '7', logo_retour: '6' ,
        offre_nouveau: '7', offre_retour: '6' },
    ];
  }

  parse(value: string) {
    return parseInt(value);
  }
}
